import React from 'react';

export function CloseIcon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width || '10'}
      height={height || '10'}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99977 4.25444L0.899889 0.154551C0.800474 0.058533 0.667324 0.00540298 0.529117 0.00660396C0.39091 0.00780495 0.258703 0.0632409 0.160972 0.160972C0.0632409 0.258703 0.00780497 0.39091 0.00660398 0.529117C0.005403 0.667324 0.0585331 0.800474 0.154551 0.899889L4.25391 4.99977L0.154551 9.09966C0.105577 9.1486 0.0667215 9.20671 0.0402036 9.27066C0.0136857 9.33462 2.45072e-05 9.40317 3.29429e-08 9.47241C-2.44413e-05 9.54164 0.0135883 9.61021 0.040061 9.67418C0.0665336 9.73816 0.105348 9.79629 0.154287 9.84526C0.203227 9.89424 0.261334 9.93309 0.325289 9.95961C0.389245 9.98613 0.457798 9.99979 0.527034 9.99981C0.596269 9.99984 0.664832 9.98623 0.728806 9.95975C0.792781 9.93328 0.850915 9.89447 0.899889 9.84553L4.99977 5.74511L9.09966 9.84553C9.14863 9.8945 9.20678 9.93335 9.27076 9.95985C9.33475 9.98636 9.40333 10 9.47259 10C9.54185 10 9.61044 9.98636 9.67442 9.95985C9.73841 9.93335 9.79655 9.8945 9.84553 9.84553C9.8945 9.79655 9.93335 9.73841 9.95985 9.67442C9.98636 9.61044 10 9.54185 10 9.47259C10 9.40333 9.98636 9.33475 9.95985 9.27076C9.93335 9.20678 9.8945 9.14863 9.84553 9.09966L5.74511 4.99977L9.84553 0.899889C9.94436 0.800981 9.99986 0.666861 9.99981 0.527034C9.99976 0.387206 9.94417 0.253125 9.84526 0.154287C9.74636 0.0554494 9.61224 -4.93911e-05 9.47241 3.29824e-08C9.33258 4.94571e-05 9.1985 0.0556431 9.09966 0.154551L4.99977 4.25391V4.25444Z"
        fill="#7E8A93"
      />
    </svg>
  );
}

export function CloseIconBold() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.302046 7.59408C-0.100682 7.99681 -0.100682 8.64977 0.302046 9.05249C0.704774 9.45522 1.35773 9.45522 1.76045 9.05249L4.6774 6.13555L7.59434 9.05249C7.99707 9.45522 8.65002 9.45522 9.05274 9.05249C9.45547 8.64977 9.45547 7.99681 9.05274 7.59408L6.1358 4.67714L9.05249 1.76045C9.45522 1.35773 9.45522 0.704774 9.05249 0.302046C8.64976 -0.100682 7.99681 -0.100682 7.59408 0.302046L4.6774 3.21874L1.76071 0.302046C1.35798 -0.100682 0.705027 -0.100682 0.302299 0.302046C-0.100429 0.704774 -0.100429 1.35773 0.302299 1.76045L3.21899 4.67714L0.302046 7.59408Z"
        fill="currentColor"
      />
    </svg>
  );
}
